/* Lasclay : configurateur de produits personnalisés + formulaire de soumission.
   Vanilla JS, aucune dépendance. Aperçu 2D : le logo du client est superposé
   à la photo studio du produit, dans une zone bornée propre à chaque produit. */
(function () {
  'use strict';

  var LOGO_MAX = 10 * 1024 * 1024;
  var APERCU_OK = /^image\/(png|jpeg|svg\+xml|webp)$/;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, attrs, texte) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) { if (attrs[k] !== null && attrs[k] !== undefined) e.setAttribute(k, attrs[k]); }
    if (texte !== undefined) e.textContent = texte;
    return e;
  }
  function paliers(texte) { // "100:5,250:10" -> [{q:100, v:5}, ...] trié
    return String(texte || '').split(/[,;\n]/).map(function (s) {
      var m = s.split(':'); return { q: parseInt(m[0], 10), v: parseFloat(String(m[1] || '').replace(',', '.')) };
    }).filter(function (x) { return x.q > 0 && !isNaN(x.v); }).sort(function (a, b) { return a.q - b.q; });
  }
  function auPalier(liste, q) { var v = 0; liste.forEach(function (x) { if (q >= x.q) v = x.v; }); return v; }

  // État partagé avec le formulaire de soumission (même page ou page dédiée).
  // `touche` : le client a réellement configuré quelque chose. Tant que non, rien du configurateur
  // ne suit la demande, sinon le choix par défaut (1er produit, 1re couleur) passe pour son choix.
  var partage = window.LasclayPerso = window.LasclayPerso || { config: null, logo: null, maquette: null, touche: false, ecouteurs: [] };
  function publier() { partage.ecouteurs.forEach(function (f) { try { f(partage); } catch (e) {} }); }

  /* ================================================================
     Configurateur
     ================================================================ */
  function initPerso(sec) {
    if (sec.__lvPerso) return; sec.__lvPerso = true;
    var data;
    try { data = JSON.parse($('[data-lv-perso-data]', sec).textContent); } catch (e) { return; }
    if (!data.produits || !data.produits.length) return;
    var en = data.langue === 'en';
    var T = en
      ? { min: 'Minimum order: {n} units per design.', nonApercu: 'Preview not available for this format. Our team will prepare the proof from your file.', trop: 'File too large (10 MB max).', copie: 'Link copied', glisser: 'Drag the logo to place it', aucun: 'No logo yet', sur: 'on request', ajout: 'Add your logo to see it here' }
      : { min: 'Minimum de commande : {n} unités par modèle.', nonApercu: "Aperçu non disponible pour ce format. L'équipe préparera l'épreuve à partir de votre fichier.", trop: 'Fichier trop lourd (10 Mo maximum).', copie: 'Lien copié', glisser: 'Glissez le logo pour le placer', aucun: 'Pas encore de logo', sur: 'sur demande', ajout: 'Ajoutez votre logo pour le voir ici' };
    var argent = new Intl.NumberFormat(en ? 'en-CA' : 'fr-CA', { style: 'currency', currency: data.devise || 'CAD' });
    var fmt = function (cents) { return argent.format(cents / 100); };
    var hex = {};
    String(data.pastilles || '').split('\n').forEach(function (l) { var i = l.indexOf('='); if (i > 0) hex[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim(); });
    var remises = paliers(data.remises);
    function liste(t) { return String(t || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean); }
    // minimum et paliers : ceux du produit s'il en a (ex. manteaux), sinon ceux de la section
    function minimumDe(p) { return p && p.minimum > 0 ? p.minimum : (data.minimum || 20); }
    function quantitesDe(p) { var l = liste(p && p.quantites); return l.length ? l : liste(data.quantites); }

    var etat = { p: 0, c: 0, t: null, q: null, s: 0.7, cx: 0.5, cy: 0.5, te: 'originale', lasclay: true };
    var logoURL = null, logoFichier = null, logoApercu = false;

    var img = $('[data-produit-img]', sec), zone = $('[data-zone]', sec), boite = $('[data-logo]', sec), logoImg = $('[data-logo-img]', sec);
    var aide = $('[data-zone-aide]', sec), outils = $('[data-outils]', sec);

    // --- restauration : lien partagé (#personnaliser=...) ou dernière session
    try {
      var h = decodeURIComponent(location.hash || '');
      var m = h.match(/perso=(\{.*\})/);
      var sauve = m ? JSON.parse(m[1]) : JSON.parse(localStorage.getItem('lv-perso') || 'null');
      if (sauve) {
        var ip = data.produits.map(function (p) { return p.handle; }).indexOf(sauve.p);
        if (ip >= 0) {
          etat.p = ip; ['c', 't', 'q', 's', 'cx', 'cy', 'te', 'lasclay'].forEach(function (k) { if (sauve[k] !== undefined) etat[k] = sauve[k]; });
          if (m || sauve.touche) partage.touche = true; // lien partagé, ou modèle configuré lors d'une visite précédente
        }
      }
    } catch (e) {}

    // Tout geste du client dans le configurateur compte comme une configuration. Écouté en capture,
    // donc avant les gestionnaires qui appellent memoriser() : le geste est enregistré avec le modèle.
    function toucher() { partage.touche = true; }
    ['change', 'input', 'drop'].forEach(function (ev) { sec.addEventListener(ev, toucher, true); });
    sec.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('button')) toucher(); }, true);

    function produit() { return data.produits[etat.p]; }
    if (!etat.q) etat.q = quantitesDe(produit())[0] || minimumDe(produit());
    // prix corporatif = pourcentage du prix affiché sur le site (lu à l'affichage de la page)
    function prixCorpo(p) { return Math.round(p.prix * (data.pourcentage || 60) / 100); }
    function prixUnitaire() {
      var p = produit();
      var sup = etat.t && data.techniques[etat.t] ? data.techniques[etat.t].sup : 0;
      return Math.max(0, Math.round((prixCorpo(p) + sup) * (1 - auPalier(remises, etat.q) / 100)));
    }
    function aPartirDe(p) {
      var q = quantitesDe(p); var qMax = q[q.length - 1] || minimumDe(p);
      return Math.round(prixCorpo(p) * (1 - auPalier(remises, qMax) / 100));
    }

    // --- 1. produits
    var boxProduits = $('[data-produits]', sec);
    data.produits.forEach(function (p, i) {
      var lab = el('label', { class: 'lvc-carte-produit' });
      var inp = el('input', { type: 'radio', name: 'lv-produit-' + sec.id, value: i });
      if (i === etat.p) inp.checked = true;
      inp.addEventListener('change', function () {
        etat.p = i; etat.c = 0; etat.t = null;
        if (etat.q < minimumDe(p)) { etat.q = quantitesDe(p)[0] || minimumDe(p); champQ.value = ''; }
        construireQuantites(); rendre(true);
      });
      var im = el('img', { src: p.vignette, alt: '', loading: 'lazy', width: 200, height: 250 });
      var nom = el('span', { class: 'lvc-carte-produit__nom' }, p.titre);
      var prix = el('span', { class: 'lvc-carte-produit__prix' }, data.afficherPrix ? (en ? 'from ' : 'dès ') + fmt(aPartirDe(p)) : '');
      lab.appendChild(inp); lab.appendChild(im); lab.appendChild(nom); lab.appendChild(prix);
      boxProduits.appendChild(lab);
    });

    // La zone est donnée en % de la photo (comme pour la maquette téléchargée) : on la reporte sur la
    // photo telle qu'affichée, en contain dans une scène 4:5. Sans effet pour les photos déjà en 4:5.
    function placerZone() {
      var z = produit().zone, sc = img.parentElement;
      var W = sc.clientWidth, H = sc.clientHeight, nw = img.naturalWidth, nh = img.naturalHeight;
      var bx = 0, by = 0, bw = 100, bh = 100;
      if (W && H && nw && nh) {
        var k = Math.min(W / nw, H / nh);
        bw = nw * k / W * 100; bh = nh * k / H * 100; bx = (100 - bw) / 2; by = (100 - bh) / 2;
      }
      zone.style.left = (bx + z.x * bw / 100) + '%'; zone.style.top = (by + z.y * bh / 100) + '%';
      zone.style.width = (z.w * bw / 100) + '%'; zone.style.height = (z.h * bh / 100) + '%';
    }
    img.addEventListener('load', function () { placerZone(); placer(); });
    window.addEventListener('resize', placer);
    window.addEventListener('resize', placerZone);

    // --- 5. quantités
    var boxQ = $('[data-quantites]', sec), champQ = $('[data-quantite]', sec);
    function construireQuantites() {
      boxQ.innerHTML = '';
      quantitesDe(produit()).forEach(function (q) {
        var b = el('button', { type: 'button', 'data-q': q }, String(q));
        b.addEventListener('click', function () { etat.q = q; champQ.value = ''; rendre(); });
        boxQ.appendChild(b);
      });
    }
    construireQuantites();
    champQ.addEventListener('input', function () { var v = parseInt(champQ.value, 10); if (v > 0) { etat.q = v; rendre(); } });

    // --- 4. logo
    var champF = $('[data-fichier]', sec), nomF = $('[data-fichier-nom]', sec), depot = $('[data-depot]', sec);
    function lireFichier(f) {
      if (!f) return;
      if (f.size > LOGO_MAX) { nomF.hidden = false; nomF.textContent = T.trop; return; }
      if (logoURL) URL.revokeObjectURL(logoURL);
      logoFichier = f; logoApercu = APERCU_OK.test(f.type);
      logoURL = logoApercu ? URL.createObjectURL(f) : null;
      nomF.hidden = false;
      nomF.textContent = f.name + (logoApercu ? '' : ' · ' + T.nonApercu);
      if (logoApercu) logoImg.src = logoURL;
      rendre();
    }
    champF.addEventListener('change', function () { lireFichier(champF.files[0]); });
    ['dragover', 'dragenter'].forEach(function (ev) { depot.addEventListener(ev, function (e) { e.preventDefault(); depot.classList.add('is-survol'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { depot.addEventListener(ev, function () { depot.classList.remove('is-survol'); }); });
    depot.addEventListener('drop', function (e) { e.preventDefault(); if (e.dataTransfer.files[0]) lireFichier(e.dataTransfer.files[0]); });
    $('[data-garder-lasclay]', sec).addEventListener('change', function (e) { etat.lasclay = e.target.checked; rendre(); });

    // --- outils d'aperçu
    var taille = $('[data-taille]', sec);
    taille.addEventListener('input', function () { etat.s = taille.value / 100; placer(); memoriser(); });
    $$('[data-teinte] button', sec).forEach(function (b) {
      b.addEventListener('click', function () { etat.te = b.getAttribute('data-v'); rendre(); });
    });
    $('[data-centrer]', sec).addEventListener('click', function () { etat.cx = 0.5; etat.cy = 0.5; placer(); memoriser(); });

    // glisser le logo dans sa zone
    var glisse = null;
    boite.addEventListener('pointerdown', function (e) {
      e.preventDefault(); boite.setPointerCapture(e.pointerId);
      var r = zone.getBoundingClientRect();
      glisse = { x: e.clientX, y: e.clientY, cx: etat.cx, cy: etat.cy, w: r.width, h: r.height };
      boite.classList.add('is-glisse');
    });
    boite.addEventListener('pointermove', function (e) {
      if (!glisse) return;
      // la zone peut être tournée : on ramène le déplacement dans son repère
      var a = -(produit().zone.r || 0) * Math.PI / 180;
      var dx = e.clientX - glisse.x, dy = e.clientY - glisse.y;
      var rx = dx * Math.cos(a) - dy * Math.sin(a), ry = dx * Math.sin(a) + dy * Math.cos(a);
      etat.cx = glisse.cx + rx / glisse.w; etat.cy = glisse.cy + ry / glisse.h;
      placer();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) { boite.addEventListener(ev, function () { if (glisse) { glisse = null; boite.classList.remove('is-glisse'); toucher(); memoriser(); } }); });
    boite.setAttribute('tabindex', '0');
    boite.addEventListener('keydown', function (e) {
      var pas = e.shiftKey ? 0.05 : 0.01, k = e.key;
      if (k === 'ArrowLeft') etat.cx -= pas; else if (k === 'ArrowRight') etat.cx += pas;
      else if (k === 'ArrowUp') etat.cy -= pas; else if (k === 'ArrowDown') etat.cy += pas; else return;
      e.preventDefault(); toucher(); placer(); memoriser();
    });

    function placer() {
      var zr = zone.getBoundingClientRect();
      if (!zr.width || !logoImg.naturalWidth) return;
      var ratio = logoImg.naturalWidth / logoImg.naturalHeight;
      var w = etat.s * zr.width, hh = w / ratio;
      if (hh > zr.height) { hh = zr.height; w = hh * ratio; }
      var demiW = w / 2 / zr.width, demiH = hh / 2 / zr.height;
      etat.cx = Math.min(1 - demiW, Math.max(demiW, etat.cx));
      etat.cy = Math.min(1 - demiH, Math.max(demiH, etat.cy));
      boite.style.width = w + 'px'; boite.style.height = hh + 'px';
      boite.style.left = (etat.cx * 100) + '%'; boite.style.top = (etat.cy * 100) + '%';
    }
    logoImg.addEventListener('load', placer);
    window.addEventListener('resize', placer);

    function memoriser() {
      var p = produit();
      var c = p.couleurs[etat.c] || {};
      partage.config = {
        produit: p.titre, handle: p.handle, url: p.url, couleur: c.nom || '', technique: etat.t ? data.techniques[etat.t][en ? 'en' : 'fr'] : '',
        quantite: etat.q, prixUnitaire: data.afficherPrix ? fmt(prixUnitaire()) : '', total: data.afficherPrix ? fmt(prixUnitaire() * etat.q) : '',
        logoCouleur: etat.te, garderLasclay: etat.lasclay,
        position: { centreX: Math.round(etat.cx * 100), centreY: Math.round(etat.cy * 100), largeur: Math.round(etat.s * 100) }
      };
      partage.logo = logoFichier;
      // On ne garde pour la visite suivante que ce que le client a vraiment configuré.
      if (partage.touche) { try { var s = etatCourt(); s.touche = true; localStorage.setItem('lv-perso', JSON.stringify(s)); } catch (e) {} }
      publier();
    }
    function etatCourt() { return { p: produit().handle, c: etat.c, t: etat.t, q: etat.q, s: +etat.s.toFixed(2), cx: +etat.cx.toFixed(3), cy: +etat.cy.toFixed(3), te: etat.te, lasclay: etat.lasclay }; }

    // --- rendu complet
    function rendre(changeProduit) {
      var p = produit();
      if (etat.c >= p.couleurs.length) etat.c = 0;
      // couleurs
      var boxC = $('[data-couleurs]', sec); boxC.innerHTML = '';
      var etapeC = $('[data-etape-couleur]', sec);
      var aCouleurs = p.couleurs.length > 1 || (p.couleurs[0] && p.couleurs[0].nom);
      etapeC.hidden = !aCouleurs;
      p.couleurs.forEach(function (c, i) {
        var lab = el('label', { class: 'lvc-pastille', title: c.nom });
        var inp = el('input', { type: 'radio', name: 'lv-couleur-' + sec.id, value: i, 'aria-label': c.nom });
        inp.checked = i === etat.c;
        inp.addEventListener('change', function () { etat.c = i; rendre(); });
        var rond = el('span'); rond.style.background = hex[String(c.nom).toLowerCase()] || '#ccc';
        lab.appendChild(inp); lab.appendChild(rond); boxC.appendChild(lab);
      });
      $('[data-couleur-nom]', sec).textContent = p.couleurs[etat.c] ? p.couleurs[etat.c].nom : '';
      // techniques
      var boxT = $('[data-techniques]', sec); boxT.innerHTML = '';
      if (!etat.t || p.techniques.indexOf(etat.t) < 0) etat.t = p.techniques[0] || null;
      p.techniques.forEach(function (k) {
        var t = data.techniques[k]; if (!t) return;
        var lab = el('label', { class: 'lvc-option' });
        var inp = el('input', { type: 'radio', name: 'lv-tech-' + sec.id, value: k }); inp.checked = k === etat.t;
        inp.addEventListener('change', function () { etat.t = k; rendre(); });
        lab.appendChild(inp);
        lab.appendChild(el('span', {}, t[en ? 'en' : 'fr'] + (data.afficherPrix && t.sup ? ' (+' + fmt(t.sup) + ')' : '')));
        boxT.appendChild(lab);
      });
      // image et zone
      var c = p.couleurs[etat.c];
      if (c && img.getAttribute('src') !== c.image) img.src = c.image;
      img.alt = p.titre + (c && c.nom ? ' · ' + c.nom : '');
      var z = p.zone;
      zone.hidden = false;
      placerZone();
      zone.style.transform = z.r ? 'rotate(' + z.r + 'deg)' : '';
      zone.setAttribute('data-tech', etat.t || '');
      boite.hidden = !logoApercu;
      boite.setAttribute('data-teinte', etat.te);
      aide.textContent = logoApercu ? T.glisser : (logoFichier ? T.nonApercu : T.ajout);
      outils.hidden = !logoApercu;
      taille.value = Math.round(etat.s * 100);
      $$('[data-teinte] button', sec).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === etat.te ? 'true' : 'false'); });
      $('[data-garder-lasclay]', sec).checked = etat.lasclay;
      // quantités et prix
      $$('button', boxQ).forEach(function (b) { b.setAttribute('aria-pressed', parseInt(b.getAttribute('data-q'), 10) === etat.q ? 'true' : 'false'); });
      var alerte = $('[data-alerte-min]', sec);
      var minP = minimumDe(produit());
      alerte.hidden = etat.q >= minP; alerte.textContent = T.min.replace('{n}', minP);
      var boxPrix = $('[data-prix]', sec);
      boxPrix.hidden = !data.afficherPrix; $('[data-prix-note]', sec).hidden = !data.afficherPrix;
      if (data.afficherPrix) {
        var u = prixUnitaire();
        $('[data-prix-unitaire]', sec).textContent = fmt(u);
        $('[data-prix-total]', sec).textContent = fmt(u * etat.q);
      }
      if (changeProduit && logoApercu) { etat.cx = 0.5; etat.cy = 0.5; }
      requestAnimationFrame(placer);
      memoriser();
    }

    // --- image de l'aperçu (PNG), pour téléchargement et pour la soumission
    function composer() {
      return new Promise(function (ok) {
        if (!img.complete || !img.naturalWidth) return ok(null);
        var W = img.naturalWidth, H = img.naturalHeight;
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var cx = cv.getContext('2d');
        cx.fillStyle = '#fff'; cx.fillRect(0, 0, W, H);
        try { cx.drawImage(img, 0, 0, W, H); } catch (e) { return ok(null); }
        if (logoApercu && logoImg.naturalWidth) {
          var z = produit().zone;
          var zx = z.x / 100 * W, zy = z.y / 100 * H, zw = z.w / 100 * W, zh = z.h / 100 * H;
          var ratio = logoImg.naturalWidth / logoImg.naturalHeight;
          var w = etat.s * zw, hh = w / ratio; if (hh > zh) { hh = zh; w = hh * ratio; }
          cx.save();
          cx.translate(zx + zw / 2, zy + zh / 2); cx.rotate((z.r || 0) * Math.PI / 180); cx.translate(-zw / 2, -zh / 2);
          var lx = etat.cx * zw - w / 2, ly = etat.cy * zh - hh / 2;
          if (etat.t === 'etiquette' || etat.t === 'ecusson') {
            var pad = Math.max(w, hh) * 0.12;
            cx.fillStyle = etat.t === 'ecusson' ? '#efe8da' : '#1c1c1c';
            cx.fillRect(lx - pad, ly - pad, w + 2 * pad, hh + 2 * pad);
          }
          var filtres = { blanc: 'brightness(0) invert(1)', noir: 'brightness(0)' };
          var f = filtres[etat.te] || '';
          if (etat.t === 'gravure') f = 'grayscale(1) sepia(0.9) brightness(0.45) contrast(1.2)';
          if (f && 'filter' in cx) cx.filter = f;
          if (etat.t === 'gravure' || etat.t === 'impression') cx.globalCompositeOperation = 'multiply';
          cx.drawImage(logoImg, lx, ly, w, hh);
          cx.restore();
        }
        try { cv.toBlob(function (b) { ok(b); }, 'image/png'); } catch (e) { ok(null); } // image non lisible (CORS) : pas d'aperçu
      });
    }
    partage.composer = composer;

    $('[data-telecharger]', sec).addEventListener('click', function () {
      composer().then(function (b) {
        if (!b) return;
        var a = el('a', { href: URL.createObjectURL(b), download: 'lasclay-apercu-' + produit().handle + '.png' });
        document.body.appendChild(a); a.click(); a.remove();
      });
    });
    $('[data-partager]', sec).addEventListener('click', function (e) {
      var url = location.href.split('#')[0] + '#' + sec.id + '?perso=' + encodeURIComponent(JSON.stringify(etatCourt()));
      var b = e.currentTarget, avant = b.textContent;
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        b.textContent = T.copie; setTimeout(function () { b.textContent = avant; }, 1800);
      }).catch(function () { window.prompt('', url); });
    });
    $('[data-soumettre]', sec).addEventListener('click', function () {
      memoriser();
      composer().then(function (b) {
        partage.maquette = b; publier();
        var cible = document.querySelector(data.cibleSoumission || '#soumission');
        if (cible) { cible.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        else { location.href = '/pages/cadeaux-corporatifs' + (data.cibleSoumission || '#soumission'); }
      });
    });

    rendre();
  }

  /* ================================================================
     Formulaire de soumission
     ================================================================ */
  function lireBase64(blob) {
    return new Promise(function (ok, ko) {
      var r = new FileReader();
      r.onload = function () { ok(String(r.result).split(',')[1] || ''); };
      r.onerror = ko; r.readAsDataURL(blob);
    });
  }
  function initSoumission(form) {
    if (form.__lvSoum) return; form.__lvSoum = true;
    var envoi = form.getAttribute('data-envoi');
    var en = (document.documentElement.lang || '').slice(0, 2) === 'en';
    var resume = $('[data-resume]', form), resumeChamp = $('[data-resume-champ]', form), vignette = $('[data-maquette]', form);
    var champLogo = $('[data-logo-soumission]', form), boxLogo = $('[data-bloc-logo]', form), statut = $('[data-statut]', form);
    if (!envoi && boxLogo) boxLogo.hidden = true; // le formulaire de contact Shopify ne transporte pas de fichier

    function majResume(p) {
      var c = p.config; if (!c || !p.touche) return; // configurateur pas touché : rien à résumer
      var lignes = [
        (en ? 'Product: ' : 'Produit : ') + c.produit + (c.couleur ? ' · ' + c.couleur : ''),
        (en ? 'Technique: ' : 'Technique : ') + (c.technique || '–'),
        (en ? 'Quantity: ' : 'Quantité : ') + c.quantite + (c.prixUnitaire ? ' · ' + c.prixUnitaire + (en ? '/unit, about ' : '/u, environ ') + c.total : ''),
        (en ? 'Logo colour: ' : 'Couleur du logo : ') + c.logoCouleur + ' · ' + (c.garderLasclay ? (en ? 'keep Lasclay label' : 'étiquette Lasclay conservée') : (en ? 'without Lasclay label' : 'sans étiquette Lasclay')),
        (en ? 'Logo file: ' : 'Fichier du logo : ') + (p.logo ? p.logo.name : (en ? 'none yet' : 'aucun pour le moment'))
      ];
      if (resume) { resume.hidden = false; $('[data-resume-texte]', resume).textContent = lignes.join('\n'); }
      if (resumeChamp) resumeChamp.value = lignes.join('\n');
      var q = $('[name="contact[Quantité]"]', form); if (q && !q.value) q.value = c.quantite;
      if (vignette && p.maquette) { vignette.hidden = false; vignette.src = URL.createObjectURL(p.maquette); }
    }
    partage.ecouteurs.push(majResume);
    if (partage.config && partage.touche) majResume(partage);

    if (!envoi) return; // envoi natif Shopify (courriel à la boutique)

    // Repli : envoi par le formulaire de contact Shopify, exactement comme un formulaire Shopify
    // ordinaire. requestSubmit() repasse par les écouteurs de Shopify (vérification hCaptcha, puis
    // envoi) ; __lvRepli laisse passer cet envoi-là dans notre propre écouteur.
    function envoyerParShopify() {
      form.__lvRepli = true;
      var parti = false;
      function partir(natif) {
        if (parti) return; parti = true;
        if (!natif && typeof form.requestSubmit === 'function') form.requestSubmit();
        else HTMLFormElement.prototype.submit.call(form);
      }
      var captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && typeof captcha.protect === 'function' && !form.dataset.hcaptchaBound) {
        // hCaptcha pas encore branché sur ce formulaire : on le branche, puis on envoie.
        try { captcha.protect(form, function () { partir(false); }); setTimeout(function () { partir(true); }, 6000); return; } catch (err) {}
      }
      partir(false);
    }

    // En CAPTURE et avec stopImmediatePropagation : Shopify protège ses formulaires de contact par
    // un script qui écoute « submit » (sur le document, et sur le formulaire une fois hCaptcha
    // branché) et relance lui-même l'envoi natif. Sans cet arrêt, la demande part dans Missive ET
    // la page file vers la vérification hCaptcha de /challenge, puis vers un 2e courriel Shopify.
    form.addEventListener('submit', function (e) {
      if (form.__lvRepli) return; // repli en cours : on laisse faire Shopify
      e.preventDefault(); e.stopImmediatePropagation();
      if (form.querySelector('[name="contact[site]"]').value) return; // pot de miel
      var bouton = $('[type="submit"]', form); bouton.disabled = true;
      statut.hidden = false; statut.className = 'lvc-statut'; statut.textContent = en ? 'Sending…' : 'Envoi en cours…';
      var champs = {};
      $$('input, select, textarea', form).forEach(function (i) {
        var m = (i.name || '').match(/^contact\[(.+)\]$/); if (!m || i.type === 'file') return;
        if ((i.type === 'checkbox' || i.type === 'radio') && !i.checked) return;
        champs[m[1]] = champs[m[1]] ? champs[m[1]] + ', ' + i.value : i.value;
      });
      var logo = (champLogo && champLogo.files[0]) || partage.logo || null;
      if (logo && logo.size > LOGO_MAX) { statut.className = 'lvc-statut is-erreur'; statut.textContent = en ? 'Logo file too large (10 MB max).' : 'Fichier du logo trop lourd (10 Mo maximum).'; bouton.disabled = false; return; }
      Promise.all([logo ? lireBase64(logo) : null, partage.maquette ? lireBase64(partage.maquette) : null]).then(function (b64) {
        return fetch(envoi, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            champs: champs, configuration: partage.touche ? partage.config : null, langue: en ? 'en' : 'fr', page: location.href.split('#')[0],
            logo: logo ? { nom: logo.name, type: logo.type, base64: b64[0] } : null,
            maquette: b64[1] ? { nom: 'apercu.png', type: 'image/png', base64: b64[1] } : null
          })
        });
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        form.reset(); if (resume) resume.hidden = true; if (vignette) vignette.hidden = true;
        statut.className = 'lvc-statut is-ok';
        statut.textContent = en ? 'Thank you! Your request is in. We reply within two business days with a quote and a proof.' : 'Merci! Votre demande est bien reçue. Nous vous répondons d\'ici deux jours ouvrables avec une soumission et une épreuve.';
      }).then(function () { bouton.disabled = false; }, function () {
        // Le point de réception Missive ne répond pas (pas encore activé, en redéploiement, hors
        // ligne) : on envoie par le formulaire de contact Shopify pour ne jamais perdre la demande.
        // Le résumé du configurateur suit ; le logo non, et le courriel de repli est indiqué.
        if (champLogo) champLogo.disabled = true;
        var msg = $('[name="contact[body]"]', form), courriel = form.getAttribute('data-courriel') || '';
        if (msg && logo) msg.value += (msg.value ? '\n\n' : '') + (en ? '[Logo not transmitted: ' : '[Logo non transmis : ') + logo.name + (courriel ? (en ? ', to be sent to ' : ', à envoyer à ') + courriel : '') + ']';
        statut.className = 'lvc-statut'; statut.textContent = en ? 'Sending…' : 'Envoi en cours…';
        envoyerParShopify();
      });
    }, true);
  }

  function demarrer(root) {
    $$('[data-lv-perso]', root).forEach(initPerso);
    $$('[data-lv-soumission]', root).forEach(initSoumission);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { demarrer(document); }); else demarrer(document);
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
